export { Gps } from './gps'
export { Car } from './car'



// WEBPACK FOOTER //
// ./src/models/index.js